export const X_ERROR_CAUSE_ID = 'X-ERROR-CAUSE-ID'
export const X_ERROR_SOURCE_ID = 'X-ERROR-SOURCE-ID'
export const X_ERROR_TRACE_ID = 'X-ERROR-TRACE-ID'
